export function getMostRestrictiveValue(a: number, b?: number): number {
  if (b === undefined) return a;
  if (a === -1) return b;
  if (b === -1) return a;
  return Math.min(a, b);
}
